import { TOPIC_IS_STARTING, TOPIC_STARTED_SUCCESSFULLY, TOPIC_START_ERROR, TOPIC_START_RESET } from "../actions/action_types";

export default function topicStartReducer(state = { id: null, isStarting: false, started: false, error: false }, action) {
    switch (action.type) {
        case TOPIC_IS_STARTING:
            return {...state, isStarting: true, id: action.payload }
        case TOPIC_STARTED_SUCCESSFULLY:
            return {...state, isStarting: false, started: true }
        case TOPIC_START_ERROR:
            return {...state, isStarting: false, error: true }
        case TOPIC_START_RESET:
            return { id: null, isStarting: false, started: false, error: false }
        default:
            return state
    }
}